import type { PublishJobDto } from '@str/api/types';
import { CHANNEL_META } from '@str/shared';
import type { CSSProperties } from 'react';

import { JOB_STATUS as STATUS } from '@/lib/publish-status';
import { resultLink } from '@/lib/result-link';

/** One chip per channel with where the post ended up (or why it didn't). */
export function PublishStatus({
  jobs,
  style,
  compact = false,
}: {
  jobs: PublishJobDto[];
  style?: CSSProperties;
  compact?: boolean;
}) {
  if (!jobs.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {jobs.map((j) => {
        const s = STATUS[j.status];
        const meta = CHANNEL_META[j.channel];
        // Same rule as Results and the emails: a .local permalink was simulated, not a real post.
        const link = resultLink(j.permalink, undefined);
        return (
          <div
            key={j.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: compact ? '5px 8px' : '7px 10px',
              borderRadius: 10,
              background: s.bg,
              color: s.color,
              fontSize: 12,
              minWidth: 0,
            }}
          >
            <span
              className="dot"
              style={{ width: 8, height: 8, background: meta.color, flex: 'none' }}
            />
            <span style={{ fontWeight: 700 }}>{meta.label}</span>
            <span style={{ marginLeft: 'auto', fontWeight: 600, whiteSpace: 'nowrap' }}>
              {j.status === 'published' && link?.kind === 'link' ? (
                <a href={link.href} target="_blank" rel="noreferrer" style={{ color: s.color }}>
                  {s.label} ↗
                </a>
              ) : j.status === 'published' && link?.kind === 'simulated' ? (
                'Simulated post (preview)'
              ) : (
                s.label
              )}
            </span>
            {!compact && j.error && j.status !== 'published' && (
              <span
                title={j.error}
                style={{
                  flexBasis: '100%',
                  color: '#555',
                  fontSize: 11.5,
                  lineHeight: 1.35,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {j.error}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
